import Marquee from "react-fast-marquee";

// Original ticker artwork from the firm's site (same pictures).
const TICKER = "https://www.amadi.io/images/services-ticker.webp";

export const PhotoTicker = () => {
  return (
    <section data-testid="photo-ticker-section" className="relative overflow-hidden">
      {/* Two-tone split background (matches the source treatment) */}
      <div className="absolute inset-x-0 top-0 h-1/2 bg-forest" />
      <div className="absolute inset-x-0 bottom-0 h-1/2 bg-canvas" />

      <div className="relative py-6 md:py-8" aria-hidden="true">
        <Marquee gradient={false} speed={40} autoFill>
          <img
            src={TICKER}
            alt=""
            loading="lazy"
            decoding="async"
            className="h-40 md:h-52 w-auto max-w-none select-none pointer-events-none"
            draggable="false"
          />
        </Marquee>
      </div>
    </section>
  );
};
